import React, { useContext, useEffect, useState } from "react";
import { Grid, TextField } from "@material-ui/core";

import ScalingContext from "../../../../../context/scaling/ScalingContext";
import UserContext from "../../../../../context/users/UserContext";

export default function AdminCampaignFilter(props) {
  const { classes, search } = props;

  const { campaigns, search_value } = useContext(ScalingContext);
  const { users } = useContext(UserContext);

  const [userOptions, setUserOptions] = useState([]);

  const loading = campaigns ? false : true;

  useEffect(() => {
    // Function: Set Media Buyer Options
    if (users) {
      let media_buyer = users.filter((user) => {
        if (user.user_group === "media_buyer" && user.status === "Active")
          return user.name;
      });

      // Extract User Name from User Object and Sort By Name
      media_buyer = media_buyer.map((each) => each.name).sort();

      setUserOptions(media_buyer);
    }
  }, [users]);

  return (
    // TextField: Search Campaign By Media Buyer
    // <Grid container alignItems="center" justifyContent="flex-start">
    <Grid item xs={2} className={classes.fieldWrapper}>
      <TextField
        variant="outlined"
        margin="normal"
        size="small"
        fullWidth
        id="media_buyer"
        label="Media Buyer"
        select
        SelectProps={{
          native: true,
        }}
        disabled={loading}
        value={search_value.media_buyer ? search_value.media_buyer : "All"}
        onChange={search}
      >
        <option value="All"> All </option>{" "}
        {userOptions.map((option, index) => (
          <option key={index} value={option}>
            {" "}
            {option}{" "}
          </option>
        ))}{" "}
      </TextField>{" "}
    </Grid>
    // </Grid>
  );
}
